import { render, staticRenderFns } from "./TrunkSummary.vue?vue&type=template&id=546ce915&"
import script from "./TrunkSummary.vue?vue&type=script&lang=js&"
export * from "./TrunkSummary.vue?vue&type=script&lang=js&"
import style0 from "./TrunkSummary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports